<template>
  <div class="about">
    <h1>关于</h1>
    <p>Version is: {{ message }}</p>
   	<input v-model="message" placeholder="1.0.18" />
     <p>Designed and Made by Hexagon IIOT Teams</p>
       <p>2024-02-26</p>
  </div>
</template>


<script>
export default {
  name: 'about',
  data() {
    return {
      message: ''
    }
  },
  mounted(){
    this.$http.get('http://127.0.0.1:5233/api/Polestar/System/Get')
              .then(function (response) {

                console.log(response.data)
                console.log(response.status)
                console.log(response.statusText)
                console.log(response.headers)
                console.log(response.config)

              })
              .catch(function (error) {

                console.log(error);

              });
  }
}
</script>